import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "50",
  height: "45",
  viewBox: "0 0 50 45",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("title", null, "icon-social__facebook", -1),
    _createElementVNode("path", {
      d: "M43 39.033A1.97 1.97 0 0 1 41.038 41h-9.22V27.033h4.707l.688-5.41h-5.396v-3.541c0-1.574.393-2.656 2.649-2.656h2.844v-4.918c-.49-.098-2.157-.197-4.218-.197-4.12 0-6.964 2.558-6.964 7.18v4.034H21.42v5.41h4.708v13.967H8.962A1.97 1.97 0 0 1 7 38.934V6.967A1.97 1.97 0 0 1 8.962 5h32.076A1.97 1.97 0 0 1 43 6.967v32.066z",
      "fill-rule": "evenodd"
    }, null, -1)
  ]))]))
}
export default { render: render }